import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Text, Icon, showDeleteDialog } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { AuthorizerContext } from 'app/providers/acl/AclProvider';

export default function SocialNetworksListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const authorizer = React.useContext(AuthorizerContext);

	const editSocialNetwork = () => {
		dispatch(
			showFastAddDialog({
				module: 'socialnetworks',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh,
				additionalProps: { disableIdentityAssociation: true }
			})
		);
	};

	const deleteSocialNetwork = () =>
		dispatch(
			showDeleteDialog({
				module: 'socialnetworks',
				id: props.model.sone_uid,
				title: props.model.sone_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			<IconButton size="small" onClick={editSocialNetwork}>
				<Icon icon="pencil" />
			</IconButton>
			<IconButton size="small" onClick={deleteSocialNetwork} edge="end">
				<Icon icon="delete" />
			</IconButton>
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" alignItems="center">
				<Grid size={12} className="inline-flex items-center">
					{/* WARNING */}
					{props.model.sone_warning_desc && (
						<Tooltip title={props.model.sone_warning_desc} arrow>
							<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
						</Tooltip>
					)}
					{/* BLOCKED */}
					{props.model.sone_blocked_desc && (
						<Tooltip title={props.model.sone_blocked_desc} arrow>
							<Icon className="mr-2" icon="block" color="error.main" />
						</Tooltip>
					)}
					{/* ICON */}
					<Icon className="mr-2" icon={props.model.soty_icon || 'web'} />
					{/* DESCRIPTION */}
					<Text className="font-600" variant="subtitle2">
						{props.model.sone_description || props.model.soty_title}
					</Text>
				</Grid>
				<Grid size={12}>
					{/* URL */}
					<ButtonLink href={props.model.sone_title}>{props.model.sone_title}</ButtonLink>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
